import { render, staticRenderFns } from "./CourseWare.vue?vue&type=template&id=dabe8344&scoped=true"
import script from "./CourseWare.vue?vue&type=script&lang=js"
export * from "./CourseWare.vue?vue&type=script&lang=js"
import style0 from "./CourseWare.vue?vue&type=style&index=0&id=dabe8344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabe8344",
  null
  
)

export default component.exports